<template>
  <v-app>
    <v-toolbar color="green lighten-2" app>
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-side-icon></v-toolbar-side-icon>
    </v-toolbar>
    <v-content>
      <v-container fluid ma-0 pa-0 fluid ma-0 pa-0 fill-height>
        <v-container>
  <v-card>
    <v-tabs
      v-model="tab"
      background-color="primary"
      dark
    >
      <v-tab v-for="item in items"
        :key="item.tab"
      >
        {{ item.tab }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item key="Планирование работ по ДН">
          <dnplan />
      </v-tab-item>
      <v-tab-item key="Отчет по ДН">
          <dnreport />
      </v-tab-item>
      <v-tab-item key="Загрузка вектора">
          <vector-upload />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
        </v-container>
      </v-container>
    </v-content>

     <v-bottom-nav app
      active.sync=1
      value="true"
      absolute
      color="green"
    >
    </v-bottom-nav>
  </v-app>
</template>
<script>
import Dnplan from '../components/dnplan'
import Dnreport from '../components/dnreport'
import VectorUpload from '../components/vectorUpload'
export default {
  name: 'otdeldn',
  components: {
    Dnplan,
    Dnreport,
    VectorUpload
  },
  data () {
    return {
      tab: null,
        items: [
          { tab: 'Планирование работ по ДН'},
          { tab: 'Отчет по ДН'},
          { tab: 'Загрузка вектора'},
        ],
      title: "ФБУ РОСЛЕСОЗАЩИТА. ОТДЕЛ ДНиГИС"
    }
  },
  mounted: function () {
    
  },
  computed: {
  },
  methods: {
  },
  watch: {
  }
}
</script>